var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48 26c-1.1 0-2 .9-2 2v26h-36v-36h26c1.1 0 2-.9 2-2s-.9-2-2-2h-28c-1.1 0-2 .9-2 2v40c0 1.1.9 2 2 2h40c1.1 0 2-.9 2-2v-28c0-1.1-.9-2-2-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56 6h-12c-1.1 0-2 .9-2 2s.9 2 2 2h7.2l-20.6 20.6c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6l20.6-20.6v7.2c0 1.1.9 2 2 2s2-.9 2-2v-12c0-1.1-.9-2-2-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtLink);
export default __webpack_public_path__ + "static/media/ext-link.d88f1c482749250834717be91224aa92.svg";
export { ForwardRef as ReactComponent };